import compare from '@/ui/ui_compare';
import favorites from '@/ui/ui_favorites';
import search from '@/ui/search.ui.js';
import feedback from '@/ui/ui_feedback';
import comments from '@/ui/ui_comments';
import reviews from '@/ui/ui_reviews';
import menu from '@/ui/ui_menu';
import accessories from '@/ui/ui_accessories';
import product from '@/ui/ui_product';
import addCartCounter from '@/ui/ui_add-cart-counter';
import triggerEvents from '@/ui/ui_trigger-events';
import ajaxReviews from '@/ui/ui_ajax-reviews/reviews';
import widget from '@/ui/widget';

export {
  compare,
  favorites,
  search,
  feedback,
  comments,
  reviews,
  menu,
  accessories,
  product,
  addCartCounter,
  triggerEvents,
  ajaxReviews,
  widget,
};
